import { render } from "./globalAppError.vue?vue&type=template&id=eea005ec"
import script from "./globalAppError.vue?vue&type=script&lang=js"
export * from "./globalAppError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__